import React from "react";
import { Crosshair, ShieldCheck, BookOpenText, Globe2, Phone, MessageCircle, Calendar } from "lucide-react";
import { CONTACT } from "../mock";

const POINTS = [
  { icon: Crosshair,    title: "Accurate Predictions", text: "Precise & reliable astrological readings based on authentic Vedic principles." },
  { icon: ShieldCheck,  title: "Genuine Solutions",     text: "Only honest remedies — no false claims, no empty promises ever." },
  { icon: BookOpenText, title: "Vedic Wisdom",          text: "Rooted in traditional Vedic astrology passed through generations." },
  { icon: Globe2,       title: "Global Reach",          text: "Consultations available in-person and online for clients worldwide." },
];

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-image-stack">
            <div className="about-img one"><img src="/images/Chetan_1.jpeg" alt="Guruji" /></div>
            <div className="about-img two"><img src="/images/Chetan_2.jpeg" alt="Guruji" /></div>
            <div className="about-img three"><img src="/images/Chetan_3.jpeg" alt="Guruji" /></div>
            <div className="about-deco-ring" />
            <div className="about-badge">
              <strong>18+</strong>
              <span>Years of Experience</span>
            </div>
          </div>

          <div>
            <span className="section-label">About Guruji</span>
            <h2 className="section-title">
              Pandit <em>C. S. Joshi</em>
            </h2>
            <p className="section-desc">
              Known as the Top Astrologer in KR Puram, Bangalore, Guruji offers a wide
              range of astrological counseling on life issues including career, health,
              love, business, finance and marriage. His accuracy in palm reading and
              face reading have helped thousands find their true path.
            </p>
            <p className="section-desc" style={{ fontSize: 15 }}>
              People across the globe approach him for counseling — in person and
              online. Guruji believes in making astrology simple and accessible,
              providing practical advice that resonates with people from Karnataka and beyond.
            </p>

            <div className="about-points">
              {POINTS.map((p, i) => {
                const Icon = p.icon;
                return (
                  <div className="about-point" key={i}>
                    <div className="about-point-icon"><Icon size={16} /></div>
                    <h4>{p.title}</h4>
                    <p>{p.text}</p>
                  </div>
                );
              })}
            </div>

            <div className="about-actions">
              <a href="#consult" className="btn btn-primary"><Calendar size={16}/> Book Consultation</a>
              <a href={`tel:${CONTACT.callNumber}`} className="btn btn-call"><Phone size={16}/> Call Now</a>
              <a href={`https://wa.me/${CONTACT.whatsappNumber.replace(/\D/g,"")}`} target="_blank" rel="noreferrer" className="btn btn-wa"><MessageCircle size={16}/> WhatsApp</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
